"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.composeStrategy = void 0;
var _noop = _interopRequireDefault(require("lodash/fp/noop"));
var composeStrategy = exports.composeStrategy = function composeStrategy() {
  for (var _len = arguments.length, strategys = new Array(_len), _key = 0; _key < _len; _key++) {
    strategys[_key] = arguments[_key];
  }
  return function (navMetas) {
    strategys.reduce(function (next, strategy) {
      return function (metas) {
        strategy(metas, next);
      };
    }, _noop["default"])(navMetas);
  };
};